import {css} from '@emotion/react'
import {ExperimentOutlined, QuestionCircleOutlined} from '@ant-design/icons'

const Message = ({children}) => {
    return <p>{children}</p>
}

const Questions = ({children}) => {
    if (! children || 0 === children.length) {
        return null
    }

    return <>
        <p><QuestionCircleOutlined /> 问题：</p>

        <ul>
            {children.map(s => <li key={s}>{s}</li>)}
        </ul>
    </>
}

const Suggestions = ({children}) => {
    if (! children || 0 === children.length) {
        return null
    }

    return <>
        <p><ExperimentOutlined /> 建议：</p>

        <ul>
            {children.map(s => <li key={s}>{s}</li>)}
        </ul>
    </>
}

export const ResponseBodyClarificationJson = ({message, ...props}) => {
    const {
        message: msg,
        questions,
        suggestions,
    } = JSON.parse(message.content)

    return (
        <div
            {...props}
        >
            <Message>{msg}</Message>
            <Questions>{questions}</Questions>
            <Suggestions>{suggestions}</Suggestions>
        </div>
    )
}
